<template>
  <div style="height: 100%" v-loading="loading">
    <div class="iq-top-navbar">
      <el-page-header @back="goBack" :content="id ? '编辑商品' : '新增商品'"> </el-page-header>
    </div>
    <!--    内容    -->
    <div class="center-content">
      <div class="iq-card-body">
        <div class="form-item" style="height: 100%" v-if="steps == 5">
          <el-result icon="success" title="商品提交成功，请耐心等待后台审核!">
            <template slot="extra">
              <el-button type="primary" size="medium" @click="goBack()">返回</el-button>
            </template>
          </el-result>
        </div>
        <template v-else>
          <el-steps :active="steps" simple>
            <el-step title="基本信息" icon="el-icon-tickets" :status="steps == 1 ? 'finish' : 'process'" @click.native="handleClick(1, 'step1')"></el-step>
            <el-step title="商品设置" icon="el-icon-setting" :status="steps == 2 ? 'finish' : 'process'" @click.native="handleClick(2, 'step2')"></el-step>
            <el-step title="购买须知" icon="el-icon-edit" :status="steps == 3 ? 'finish' : 'process'" @click.native="handleClick(3, 'step3')"></el-step>
            <el-step title="售后服务" icon="el-icon-edit" :status="steps == 4 ? 'finish' : 'process'" @click.native="handleClick(4, 'step4')"></el-step>
          </el-steps>
          <div class="from-box">
            <el-scrollbar class="form-item" style="height: 100%">
              <el-form ref="commodityForm" :model="commodityForm" label-width="150px" :rules="rules">
                <el-dialog :visible.sync="previewImg">
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
                <div ref="step1">
                  <el-form-item label="商品名称" prop="name">
                    <el-input v-model="commodityForm.name" maxlength="50" show-word-limit> </el-input>
                  </el-form-item>
                  <el-form-item label="1:1主图 " prop="imageUrls">
                    <div class="flex-start">
                      <div class="imgBox flex-center-column" v-for="(img, index) in commodityForm.imageUrls" :key="index">
                        <el-dropdown v-if="img" class="dropdown">
                          <img
                            :src="`${CommonPath}${img}`"
                            @click="
                              previewImg = true;
                              dialogImageUrl = `${CommonPath}${img}`;
                            "
                          />
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="selectImg(index, '主图')">替换</el-dropdown-item>
                            <el-dropdown-item @click.native="$set(commodityForm.imageUrls, index, '')">删除</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>

                        <template v-else>
                          <img src="../../../assets/img/shopping/big.png" @click="selectImg(index, '主图')" />
                          <p style="font-size: 12px" @click="selectImg(index, '主图')">上传图片</p>
                        </template>
                      </div>
                    </div>
                    <div style="color: red" v-if="imgTip">{{ imgTip }}</div>
                    <div class="imgTip">主图图片要求：比例为1:1，大小3M内；至多可上传5张；</div>
                  </el-form-item>
                  <el-form-item label="商品分类" prop="categoryId" style="width: 400px">
                    <el-cascader v-model="commodityForm.categoryId" :options="commodifyCategory" :props="{checkStrictly: true, emitPath: false,value: 'id', label: 'name', children: 'childrens'}" @change="handleChange" clearable></el-cascader>
                  </el-form-item>
                  <!-- <el-form-item v-for="(item, index) in commodityForm.commodityParameters" :label="item.key" :key="item.key" :prop="'commodityParameters.' + index + '.value'" :rules="{ required: true, message: '规格设置不能为空', trigger: 'blur' }">
                    <el-input class="w-18" v-model="item.value"></el-input>
                  </el-form-item> -->
                  <!-- <el-form-item>
                    <el-button @click="nextStep('firstForm')">下一步</el-button>
                  </el-form-item> -->
                </div>
                <div ref="step2">
                  <el-form-item label="商品规格管理" :rules="{ required: true, message: '不能为空', trigger: 'blur' }">
                    <el-table class="tab" :data="commodityForm.commoditySpecifications" border style="width: 100%">
                      <el-table-column prop="coverImageUrls" align="center" label="图片" width="80px">
                        <template slot-scope="scope">
                          <el-form-item label="" :prop="'commoditySpecifications[' + scope.$index + '].coverImageUrls'" :rules="rules.coverImageUrls" class="el-form-imgBox">
                            <div class="imgBox2 flex-center">
                              <el-dropdown v-if="scope.row.coverImageUrls" class="dropdown">
                                <img
                                  :src="`${CommonPath}${scope.row.coverImageUrls}`"
                                  @click="
                                    previewImg = true;
                                    dialogImageUrl = `${CommonPath}${scope.row.coverImageUrls}`;
                                  "
                                />
                                <el-dropdown-menu slot="dropdown">
                                  <el-dropdown-item @click.native="selectImg(scope.$index, '规格图')">替换</el-dropdown-item>
                                  <el-dropdown-item @click.native="scope.row.coverImageUrls = ''">删除</el-dropdown-item>
                                </el-dropdown-menu>
                              </el-dropdown>

                              <template v-else>
                                <img src="../../../assets/img/shopping/small.png" @click="selectImg(scope.$index, '规格图')" />
                              </template>
                            </div>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="name" align="center" label="规格名称">
                        <template slot-scope="scope">
                          <el-form-item label="" :prop="'commoditySpecifications[' + scope.$index + '].name'" :rules="rules.namegg">
                            <el-input v-model="scope.row.name" size="small" placeholder="规格名称"> </el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="name" align="guidancePrice" label="原价(元)">
                        <template slot-scope="scope">
                          <el-form-item label="" :prop="'commoditySpecifications[' + scope.$index + '].guidancePrice'" :rules="rules.guidancePrice">
                            <el-input v-model="scope.row.guidancePrice" size="small" placeholder="原价(元)" @input="validateInput(scope.row)"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="ordinaryPrice" align="center" label="售价(元)">
                        <template slot-scope="scope">
                          <el-form-item label="" :prop="'commoditySpecifications[' + scope.$index + '].ordinaryPrice'" :rules="rules.ordinaryPrice">
                            <el-input v-model="scope.row.ordinaryPrice" size="small" placeholder="售价(元)" @input="validateInput(scope.row)"></el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="stockNum" align="center" label="库存数量">
                        <template slot-scope="scope">
                          <el-form-item label="" :prop="'commoditySpecifications[' + scope.$index + '].stockNum'" :rules="rules.stockNum">
                            <el-input v-model="scope.row.stockNum" size="small" placeholder="库存数量"> </el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column prop="rank" align="center" label="排序">
                        <template slot-scope="scope">
                          <el-form-item label="" :prop="'commoditySpecifications[' + scope.$index + '].rank'" :rules="rules.rank">
                            <el-input v-model="scope.row.rank" size="small" placeholder="排序"> </el-input>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" label="启用/禁用">
                        <template slot-scope="scope">
                          <el-form-item label="">
                            <el-switch v-model="scope.row.state" :active-value="1" :inactive-value="0"> </el-switch>
                          </el-form-item>
                        </template>
                      </el-table-column>
                      <el-table-column width="150" align="center">
                        <template slot-scope="scope">
                          <el-button type="danger" size="mini" plain @click="handleDelete(scope.row, scope.$index)">
                            <i class="el-icon-delete" aria-hidden="true"></i>
                          </el-button>
                        </template>
                        <template slot="header">
                          <!-- 通过js添加行数据的按钮 -->
                          <el-button size="mini" @click="handleAdd()" type="primary" plain round>添加规格 </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="color: red" v-if="errStr">{{ errStr }}</div>
                  </el-form-item>
                  <!-- <el-form-item label="是否限购">
                    <el-radio-group v-model="commodityForm.limitType" @change="checkLimitNum">
                      <el-radio :label="0" style="margin-top: 15px">不限购</el-radio>
                      <br />
                      <el-radio :label="1" style="margin: 10px 10px 0px 0px">周期限购：每个会员，整个活动周期限购 <el-input type="number" style="width: 70px" v-model="commodityForm.limitNum" size="small" v-if="commodityForm.limitType == 1" @blur="checkLimitNum"> </el-input> 份</el-radio>
                      <br />
                      <el-radio :label="2" style="margin: 10px 10px 10px 0px">每日限购：每个会员，每日限购 <el-input type="number" style="width: 70px" v-model="commodityForm.limitNum" size="small" v-if="commodityForm.limitType == 2" @blur="checkLimitNum"> </el-input> 份</el-radio>
                      <br />
                      <el-radio :label="3"
                        >每月限购：每个会员，每月限购 <el-input type="number" style="width: 70px" v-model="commodityForm.limitNum" size="small" v-if="commodityForm.limitType == 3" @blur="checkLimitNum"></el-input> 份
                        <span style="color: #ff0000">*适用于长期活动</span>
                      </el-radio>
                    </el-radio-group>
                    <div style="color: red" v-if="errorLimitNum">{{ errorLimitNum }}</div>
                  </el-form-item> -->
                  <el-form-item label="支付等待" prop="cancellationOrder">
                    <div class="isShare-box">
                      <div>订单 <el-input type="number" v-model="commodityForm.cancellationOrder" size="small"></el-input> 分钟未支付，自动取消订单</div>
                    </div>
                  </el-form-item>
                  <el-form-item label="" prop="completionOrder">
                    <div class="isShare-box">
                      <div>订单 <el-input type="number" v-model="commodityForm.completionOrder" size="small"></el-input> 天，自动确认收货</div>
                    </div>
                  </el-form-item>
                  <!-- <el-form-item label="是否需要发货">
                    <el-switch v-model="commodityForm.isSend"> </el-switch>
                  </el-form-item> -->
                  <el-form-item label="快递费用">
                    <el-radio-group v-model="commodityForm.freightType" @change="checkMoney">
                      <el-radio :label="2" style="margin-top: 15px">免运费</el-radio>
                      <br />
                      <!-- <el-radio :label="1" style="margin: 20px 10px 20px 0">固定运费</el-radio>
                      <el-input type="number" style="width: 70px" v-model="commodityForm.freightMoney" :disabled="commodityForm.freightType == 1 ? false : true" size="small" @blur="checkMoney"></el-input> 元
                      <br /> -->
                      <el-radio :label="3">运费模板</el-radio>
                      <el-select v-model="commodityForm.freightTemplateId" :disabled="commodityForm.freightType == 3 ? false : true" size="small" placeholder="请选择">
                        <el-option v-for="(item, i) in freightTemplate" :key="i" :label="item.templateName" :value="item.id"> </el-option>
                      </el-select>
                      <template v-if="commodityForm.freightType == 3">
                        <i class="el-icon-edit" style="font-size: 14px; margin-left: 20px; cursor: pointer" @click="addBtn(commodityForm.freightTemplateId)">编辑</i>
                        <i class="el-icon-plus" style="font-size: 14px; margin: 0 10px; cursor: pointer" @click="addBtn(0)">添加</i>
                        <i class="el-icon-refresh" style="font-size: 14px; cursor: pointer" @click="LoadFreightTemplate()">刷新</i>
                      </template>
                    </el-radio-group>
                    <div style="color: red" v-if="errorStr">{{ errorStr }}</div>
                  </el-form-item>

                  <el-form-item label="是否可退单">
                    <el-radio-group v-model="commodityForm.chargebackType" @change="checkChargebackMoney">
                      <el-radio :label="1">不可退单</el-radio>
                      <el-radio :label="2">随时可退</el-radio>
                      <el-radio :label="3">支付完成24小时可退</el-radio>
                    </el-radio-group>
                    <div class="isShare-box" v-if="commodityForm.chargebackType == '2' || commodityForm.chargebackType == '3'">
                      <div>退单时，需支付手续费 <el-input v-model="commodityForm.chargebackMoney" size="small" type="number" @blur="checkChargebackMoney"> </el-input> 元，输入0元，为退单无需手续费</div>
                    </div>
                    <div style="color: red" v-if="errorChargebackMoney">{{ errorChargebackMoney }}</div>
                  </el-form-item>
                  <!-- <el-form-item>
                    <el-button type="primary" @click="prevStep">上一步</el-button>
                    <el-button @click="nextStep('secondForm')">下一步</el-button>
                  </el-form-item> -->
                </div>
                <div ref="step3">
                  <el-form-item label="购买须知">
                    <vue-tinymce v-model="commodityForm.instructions" ref="richTextEditor" :setting="setting" />
                  </el-form-item>
                  <el-form-item label="商品详情" prop="introduce">
                    <vue-tinymce v-model="commodityForm.introduce" ref="richTextEditor" :setting="setting" />
                  </el-form-item>
                  <!-- <el-form-item>
                  <el-button type="primary" @click="prevStep">上一步</el-button>
                  <el-button @click="nextStep('thirdForm')">下一步</el-button>
                </el-form-item> -->
                </div>
                <div ref="step4">
                  <el-form-item label="售后服务">
                    <vue-tinymce v-model="commodityForm.customerService" ref="richTextEditor" :setting="setting" />
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="saveCommodity('commodityForm')">提 交</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </el-scrollbar>
          </div>
        </template>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="60vw">
      <div class="flex-space-between dialog-box">
        <div class="left-box">
          <div class="flex-space-between top-box">
            <span>文件夹目录</span>
          </div>
          <el-input class="input-box" v-model="searchForm2.folderName" type="text" size="small" placeholder="文件夹名称" @keyup.enter.native="Search" clearable>
            <el-button slot="append" icon="el-icon-search" @click="Search"></el-button>
          </el-input>
          <el-scrollbar class="left-nav-wrap" style="height: calc(60vh - 60px)">
            <div class="item-box flex-start" :class="{ active: active == index }" v-for="(item, index) in AlbumData" :key="index" @click="getInfo(item, index)">
              <i class="el-icon-folder"></i>
              <span class="oneLine" style="margin-left: 5px">{{ item.name }}</span>
            </div>
          </el-scrollbar>
        </div>
        <div class="line-box"></div>
        <div class="right-box">
          <div class="flex-space-between top-box">
            <span>素材图片</span>
          </div>
          <div class="flex-end">
            <el-input class="input-box2" v-model="searchForm2.keyWord" type="text" size="small" placeholder="图片名称" @keyup.enter.native="getImgs" clearable>
              <el-button slot="append" icon="el-icon-search" @click="getImgs"></el-button>
            </el-input>
            <el-button type="info" round plain size="small" @click="getImgs()">刷新</el-button>
            <el-button type="primary" round size="small" @click="openAlbum">本地上传</el-button>
          </div>
          <template v-if="LibraryData.length > 0">
            <el-scrollbar class="left-nav-wrap" style="height: calc(60vh - 120px)">
              <div class="checkGroup flex-start flex-wrap">
                <div class="img-box" :class="{ activeImg: active == index }" v-for="(item, index) in LibraryData" :key="index">
                  <div class="top-btn flex-end">
                    <el-checkbox v-model="item.isCheck" size="medium" @change="handelCheck(index, item.isCheck)" :disabled="imgIndex != null && !item.isCheck"></el-checkbox>
                  </div>
                  <img
                    :src="`${CommonPath}${item.filePath}`"
                    @click="
                      dialogVisible = true;
                      dialogImageUrl = `${CommonPath}${item.filePath}`;
                    "
                  />
                  <div class="oneLine" style="margin-left: 5px; text-align: center">{{ item.fileName }}</div>
                </div>
              </div>
            </el-scrollbar>
            <el-pagination @current-change="ChangePage" :page-size="PageSize" :current-page="PageIndex" :total="DataTotal" layout="total, prev, pager, next, jumper"></el-pagination>
          </template>
          <el-empty :image-size="110" v-else style="height: calc(60vh - 25px)"></el-empty>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setImg">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { Commodity } from "../../../components/HospitalDomain/ShopMall/commodity";
import { CommodityCategory } from "../../../components/HospitalDomain/ShopMall/CommodityCategory";
import { Region } from "../../../components/HospitalDomain/Region";
import { Videos } from "../../../components/HospitalDomain/Videos/Videos";
import { Merchant } from "../../../components/HospitalDomain/ShopMall/Merchant";
import { MaterialLibrary } from "../../../components/HospitalDomain/ShopMall/MaterialLibrary";
import "../../../utils/aliyun-upload-sdk-1.5.3.min.js";
import "../../../utils/es6-promise.min.js";
import OSS from "../../../utils/aliyun-oss-sdk-6.17.1.min.js";
window.OSS = OSS;
var loading = null;
export default {
  name: "addCommodity",
  computed: {
    headers() {
      return {
        Authorization: "Bearer" + " " + JSON.parse(sessionStorage.getItem(this.ClientId + "Token")).access_token,
      };
    },
  },
  data() {
    var commodityCategory = new CommodityCategory(this.TokenClient, this.Services.Shopping);
    var commodity = new Commodity(this.TokenClient, this.Services.Shopping);
    var region = new Region(this.TokenClient, this.Services.Authorization);
    var regMoney = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
    var videos = new Videos(this.TokenClient, this.Services.Healthy);
    var merchant = new Merchant(this.TokenClient, this.Services.Shopping);
    var materialLibrary = new MaterialLibrary(this.TokenClient, this.Services.Shopping);
    const myValidate = (rule, value, callback) => {
      if (value > 30) {
        callback(new Error("输入不能大于30"));
      } else {
        callback();
      }
    };
    return {
      MaterialLibrary: materialLibrary,
      MerchantDomain: merchant,
      loading: false,
      VideosDomain: videos,
      regMoney: regMoney,
      dialogVisible: false,
      path: "",
      errStr: "",
      imgTip: "",
      previewImg: false,
      dialogImageUrl: "",
      errorLimitNum: "",
      errorStr: "",
      errorChargebackMoney: "",
      CommodityDomain: commodity,
      CommodityCategoryDomain: commodityCategory,
      Region: region,
      organizationId: JSON.parse(sessionStorage.getItem("userInfo")).organizationId,
      steps: 1,
      merchantInfo: {},
      id: this.$route.query.id, //列表页id
      commodityForm: {
        type: 1,
        attribute: 2,
        name: "",
        categoryId: null,
        commodityParameters: [],
        coverImageUrls: "",
        imageUrls: ["", "", "", "", ""],
        isShare: false,
        memberShare: 0,
        ordinaryShare: 0,
        commoditySpecifications: [
          {
            name: "",
            coverImageUrls: "",
            guidancePrice: null,
            ordinaryPrice: null,
            stockNum: null,
            state: 1,
            rank: 0,
          },
        ],
        limitType: 0,
        limitNum: 1,
        cancellationOrder: "30",
        completionOrder: "14",
        isSend: false,
        freightType: 2,
        freightMoney: "0",
        freightTemplateId: null,
        isInvoice: false,
        chargebackType: 1,
        chargebackMoney: 0,

        introduce: "",
        instructions: "",
        customerService: "",
      },
      commodifyCategory: [],
      freightTemplate: [],
      Image: {
        //单击图片上传控件中的图片时，放大显示
        dialogVisible: false,
        dialogImageUrl: "",
      },
      ImageContent: [], //图片列表
      ImageContentList: [], //图片上传控件加载的数据
      FileUploadUrl: this.CommonFilePath,
      originId: null,
      RichTextContent: "",
      RichTextContentTimeoutHandle: undefined,
      successCode: "",
      resVideo: "", //上传视频返回的url
      uploaded: false, //有没有上传完成
      setting: {
        menubar: false,
        cleanup: true,
        toolbar: "undo redo | fullscreen | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | image media table | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat |",
        toolbar_drawer: "sliding",
        quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
        plugins: "link image media table lists fullscreen quickbars autoresize",
        language: "zh_CN",
        max_height: 600, // 编辑区域的最大高
        min_height: 350, //编辑区域的最小高度
        images_upload_handler: (blobInfo, success, failure) => {
          let formdata = new FormData();
          // formdata.set('file', blobInfo.blob())
          // 二进制文件，文件名装入form传到后台处理
          formdata.append("file", blobInfo.blob(), blobInfo.filename());
          axios({
            method: "POST",
            headers: { "Content-Type": "multipart/form-data", Authorization: "Bearer" + " " + JSON.parse(sessionStorage.getItem(this.ClientId + "Token")).access_token },
            // 这里是你的上传地址
            url: this.CommonFilePath,
            data: formdata,
          }).then((res) => {
            if (res.data[0].isSuccess == true) {
              // 这里返回的是你图片的地址
              success(this.CommonPath + res.data[0].completeFilePath);
            } else {
              failure("图片上传失败!");
            }
          });
        },
        //上传视频配置
        file_picker_types: "media",
        file_picker_callback: (callback, value, meta) => {
          if (meta.filetype == "media") {
            let input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "video/mp4,video/AVI,video/mov,video/FLV,video/rmvb,video/mtv,video/mpeg");
            let that = this;
            input.click();
            input.onchange = function (e) {
              let file = this.files[0];
              loading = that.$loading({
                lock: true,
                // text: '正在上传视频...',
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.4)",
              });
              let ext = file.name.split(".")[1];
              if (ext !== "mp4" && ext !== "AVI" && ext !== "mov" && ext !== "FLV" && ext !== "rmvb" && ext !== "wmv" && ext !== "mtv" && ext !== "mpg" && ext !== "mpeg") {
                that.$message.error({ message: "上传资源只能是 AVI/mov/rmvb/FLV/mp4/wmv/mtv/mpg/mpeg 格式的视频!", duration: 5000, customClass: "zZindex" });
                loading.close();
                return false;
              }
              let isLt20M = file.size / 1024 / 1024 < 20;
              if (!isLt20M) {
                that.$message.error("上传视频大小不能超过20MB哦!");
                loading.close();
                return false;
              }
              that.resVideo = "";
              that.uploaded = false;
              that.uploader = that.createUploader();
              let userData = '{"Vod":{}}';
              that.uploader.addFile(file, null, null, null, userData);
              that.uploader.startUpload();
              if (that.uploaded) {
                callback(that.resVideo); //将url显示在弹框输入框中
                loading.close();
                that.uploaded = false;
              } else {
                setTimeout(() => {
                  //设置几秒后再去取数据
                  callback(that.resVideo);
                  loading.close();
                  that.uploaded = false;
                }, 5000);
              }
            };
          }
        },
        media_url_resolver: (data, resolve) => {
          try {
            resolve({ html: `<video width="745" height="420" controls="controls" src=${data.url} />` });
          } catch (e) {
            resolve({ html: "" });
          }
        },
      },
      productGroupRules: {
        productGroupNum: [{ required: true, message: "请填写商品数量", trigger: "blur" }],
        productGroupPrice: [{ required: true, message: "请填写优惠价格", trigger: "blur" }],
      },
      rules: {
        name: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        imageUrls: [{ required: true, type: "array", message: "请上传商品封面", trigger: "blur" }],
        memberShare: [
          { pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: "小数点后保留两位", trigger: "blur" },
          { required: true, message: "请输入正确的金额", trigger: "blur" },
        ],
        ordinaryShare: [
          { pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: "小数点后保留两位", trigger: "blur" },
          { required: true, message: "请输入正确的金额", trigger: "blur" },
        ],
        namegg: [{ required: true, message: "请输入规格名称", trigger: "blur" }],
        coverImageUrls: [{ required: true, message: "规格图片", trigger: "blur" }],
        guidancePrice: [
          { pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: "小数点后保留两位", trigger: "blur" },
          { required: true, message: "请输入原价", trigger: "blur" },
        ],
        ordinaryPrice: [
          { pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: "小数点后保留两位", trigger: "blur" },
          { required: true, message: "请输入商品价格", trigger: "blur" },
        ],
        stockNum: [
          { pattern: /^[1-9]\d*$/, message: "请输入正整数", trigger: "blur" },
          { required: true, message: "请输入库存量", trigger: "blur" },
        ],
        rank: [
          { pattern: /^[0-9]\d*$/, message: "请输入整数", trigger: "blur" },
          { required: true, message: "请输入排序", trigger: "blur" },
        ],
        commonFirst: [
          { pattern: /(^[0-9]\d{0,1}$)/, message: "请输入0-99的整数", trigger: "blur" },
          { required: true, message: "请输入0-99的整数", trigger: "blur" },
        ],
        commonSecond: [
          { pattern: /(^[0-9]\d{0,1}$)/, message: "请输入0-99的整数", trigger: "blur" },
          { required: true, message: "请输入0-99的整数", trigger: "blur" },
        ],
        vip1First: [
          { pattern: /(^[0-9]\d{0,1}$)/, message: "请输入0-99的整数", trigger: "blur" },
          { required: true, message: "请输入0-99的整数", trigger: "blur" },
        ],
        vip1Second: [
          { pattern: /(^[0-9]\d{0,1}$)/, message: "请输入0-99的整数", trigger: "blur" },
          { required: true, message: "请输入0-99的整数", trigger: "blur" },
        ],
        vip2First: [
          { pattern: /(^[0-9]\d{0,1}$)/, message: "请输入0-99的整数", trigger: "blur" },
          { required: true, message: "请输入0-99的整数", trigger: "blur" },
        ],
        vip2Second: [
          { pattern: /(^[0-9]\d{0,1}$)/, message: "请输入0-99的整数", trigger: "blur" },
          { required: true, message: "请输入0-99的整数", trigger: "blur" },
        ],
        publicShareMoney: [
          { pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: "小数点后保留两位", trigger: "blur" },
          { required: true, message: "请输入正确的金额", trigger: "blur" },
        ],
        categoryId: [{ required: true, message: "请选择商品分类", trigger: "change" }],
        cancellationOrder: [
          { pattern: /^[1-9]\d*$/, message: "请输入大于0，小于10000的正整数", trigger: "blur" },
          { required: true, message: "请输入正确的分钟数", trigger: "blur" },
        ],
        completionOrder: [
          { pattern: /^[1-9]\d*$/, message: "请输入大于0，小于10000的正整数", trigger: "blur" },
          { required: true, message: "请输入正确的天数", trigger: "blur" },
        ],
        originId: [{ type: "array", required: true, message: "请选择产地", trigger: "change" }],
        introduce: [{ required: true, message: "请输入商品介绍", trigger: "change" }],
        // instructions: [
        //     { required: true, message: '请输入购买须知', trigger: 'change' },
        // ],
      },
      isShare: false,
      active: 0,
      AlbumData: [],
      searchForm2: {
        keyWord: "",
        folderName: "",
      },
      PageIndex: 1,
      PageTotal: 0,
      PageSize: 0,
      DataTotal: 0,
      active: 0,
      LibraryData: [],
      isAll: false,
      checked: [],
      mainImgIndex: 0,
      imgIndex: null,
      specificationsIndex: 0,
      text: null,
    };
  },
  mounted() {
    if (this.id) {
      this.LoadFrom();
    } else {
      this.loading = true;
      this.getMerchantSet();
      let data = JSON.parse(JSON.stringify(this.commodityForm.commoditySpecifications ? this.commodityForm.commoditySpecifications : []));
      data.forEach((element) => {
        element["edit"] = true;
      });
      this.commodityForm.commoditySpecifications = data;
    }
    this.LoadCategory();
    this.LoadFreightTemplate();
    this.getShopSetting();
    this.path = `${window.location.origin}/#/ShopMall/Album`;
  },
  methods: {
    validateInput(row) {
      if (row.guidancePrice * 1 > 0 && row.guidancePrice * 1 < row.ordinaryPrice * 1) {
        this.$message({
          type: "error",
          message: "售价不能大于原价",
        });
        row.ordinaryPrice = null;
        return;
      }
    },
    setImg() {
      if (this.imgIndex == null) {
        this.$message({
          type: "error",
          message: "请选择图片!",
        });
        return;
      }
      let imgPath = this.LibraryData[this.imgIndex].filePath;
      if (this.text == "主图") {
        this.commodityForm.imageUrls[this.mainImgIndex] = imgPath;
      } else if (this.text == "规格图") {
        this.commodityForm.commoditySpecifications[this.specificationsIndex].coverImageUrls = imgPath;
      }

      this.dialogVisible = false;
    },
    handelCheck(index, isCheck) {
      if (!isCheck) {
        this.imgIndex = null;
        return;
      }
      this.imgIndex = index;
    },
    openAlbum() {
      const routerData = this.$router.resolve({
        path: "/ShopMall/Album",
      });
      window.open(routerData.href, "_blank");
    },
    getInfo(item, index) {
      this.imgIndex = null;
      this.isAll = false;
      this.active = index;
      var _this = this;
      _this.LibraryData = [];
      _this.MaterialLibrary.LibraryFiles(
        item.organizationId,
        item.id,
        _this.PageIndex,
        _this.searchForm2.keyWord,
        function (data) {
          _this.LibraryData = data.data.results;
          _this.LibraryData.forEach((item) => {
            _this.$set(item, "isCheck", false);
          });
          _this.PageIndex = data.data.pageIndex;
          _this.PageSize = data.data.pageSize;
          _this.PageTotal = data.data.pageCount;
          _this.DataTotal = data.data.dataTotal;
        },
        function (err) {
          console.log(err);
        }
      );
    },
    Search() {
      this.getList();
    },
    getImgs() {
      this.PageIndex = 1;
      this.getInfo(this.AlbumData[this.active], this.active);
    },
    ChangePage(pageIndex) {
      this.PageIndex = pageIndex;
      this.getList();
    },
    getList() {
      var _this = this;
      _this.AlbumData = [];
      _this.MaterialLibrary.OrganizaionList(
        _this.PageIndex,
        _this.searchForm2.folderName,
        function (data) {
          _this.AlbumData = data.data.results;
          if (_this.AlbumData.length > 0) {
            _this.active = 0;
            _this.getImgs();
          } else {
            _this.LibraryData = [];
          }
        },
        function (err) {
          console.log(err);
        }
      );
    },
    selectImg(index, text) {
      this.text = text;
      if (text == "主图") {
        this.mainImgIndex = index;
      } else if (text == "规格图") {
        this.specificationsIndex = index;
      }
      this.imgIndex = null;
      this.dialogVisible = true;
      this.getList();
    },
    handleClick(num, step) {
      this.steps = num;
      const divStr = this.$refs[step];
      if (divStr) {
        divStr.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    LoadFrom() {
      var _this = this;
      _this.CommodityDomain.Detail(
        _this.id,
        function (data) {
          _this.commodityForm = {
            id: data.data.id,
            type: 1,
            attribute: 2,
            name: data.data.name,
            coverImageUrls: data.data.coverImageUrls,
            imageUrls: [],
            categoryId: data.data.categoryId,
            commodityParameters: data.data.commodityParameters,
            isHot: data.data.isHot,
            isCommended: data.data.isCommended,
            isShare: data.data.isShare,
            memberShare: data.data.memberShare,
            ordinaryShare: data.data.ordinaryShare,
            commoditySpecifications: data.data.commoditySpecifications,
            commonFirst: data.data.commonFirst,
            commonSecond: data.data.commonSecond,
            vip1First: data.data.vip1First,
            vip1Second: data.data.vip1Second,
            vip2First: data.data.vip2First,
            vip2Second: data.data.vip2Second,
            isPublicShare: data.data.isPublicShare,
            publicShareMoney: data.data.publicShareMoney,
            limitType: data.data.limitType,
            limitNum: data.data.limitNum,
            cancellationOrder: data.data.cancellationOrder,
            completionOrder: data.data.completionOrder,
            isSend: data.data.isSend,
            freightType: data.data.freightType,
            freightMoney: data.data.freightMoney,
            freightTemplateId: data.data.freightTemplateId,
            isInvoice: data.data.isInvoice,
            chargebackType: data.data.chargebackType,
            chargebackMoney: data.data.chargebackMoney,
            introduce: data.data.introduce,
            instructions: data.data.instructions,
            customerService: data.data.customerService,
          };
          if (_this.commodityForm.coverImageUrls) _this.commodityForm.imageUrls = _this.commodityForm.coverImageUrls.split(",");
          //保证数组长度为5
          if (_this.commodityForm.imageUrls.length < 5) {
            let n = 5 - _this.commodityForm.imageUrls.length;
            let i = 0;
            while (i < n) {
              _this.commodityForm.imageUrls.push("");
              i++;
            }
          }
          let dataArry = JSON.parse(JSON.stringify(_this.commodityForm.commoditySpecifications ? _this.commodityForm.commoditySpecifications : []));
          dataArry.forEach((element) => {
            element["edit"] = true;
          });
          _this.commodityForm.commoditySpecifications = dataArry;
          // data.data.coverPicture.forEach((element) => {
          //   let obj = new Object();
          //   obj.url = _this.Services.Shopping + element.filePath;
          //   _this.ImageContentList.push(obj);
          //   let imgMap = {
          //     fileName: element.fileName,
          //     filePath: element.filePath,
          //   };
          //   _this.commodityForm.coverPicture.push(imgMap);
          // });
        },
        function (err) {
          console.log(err);
        }
      );
    },
    getMerchantSet() {
      var _this = this;
      _this.MerchantDomain.MerchantState(
        function (data) {
          if (data.code == "200") {
            _this.loading = true;
            _this.merchantInfo = data.data;
            if (_this.merchantInfo.state != 1) {
              _this.loading = false;
              _this.$alert("店铺功能未开通！", "提示", {
                confirmButtonText: "我知道了",
                callback: (action) => {
                  _this.$router.go(-1);
                },
              });
            } else {
              _this.getMerchantDetail()
            }
          }
        },
        function (err) {
          console.log(err);
          _this.loading = false;
          if (err.status == "404") {
            _this.$alert("店铺功能未开通！", "提示", {
              confirmButtonText: "我知道了",
              callback: (action) => {
                _this.$router.go(-1);
              },
            });
          }
        }
      );
    },
    getMerchantDetail() {
      var _this = this;
      _this.MerchantDomain.MerchantDetail(
        _this.organizationId,
        function (data) {
          if (data.code == "200") {
            if (data.data.state != 1) {
              _this.loading = false;
              _this.$alert("您的店铺已暂停使用！", "提示", {
                confirmButtonText: "我知道了",
                callback: (action) => {
                  _this.$router.go(-1);
                },
              });
            } else {
              _this.loading = false;
            }
          }
        },
        function (err) {
          console.log(err);
          _this.loading = false;
          if (err.status == "404") {
            _this.$alert("您的店铺已暂停使用！", "提示", {
              confirmButtonText: "我知道了",
              callback: (action) => {
                _this.$router.go(-1);
              },
            });
          }
        }
      );
    },
    createUploader() {
      let _this = this;
      var uploader = new AliyunUpload.Vod({
        userId: "1922508017966810",
        //上传到点播的地域，默认值为'cn-shanghai'，//eu-central-1，ap-southeast-1，更多信息请参见存储说明
        region: "cn-shanghai",
        //开始上传
        addFileSuccess: function (uploadInfo) {
          console.log(uploadInfo);
        },
        onUploadstarted: function (uploadInfo) {
          var that = this;
          let params = {
            title: "视频名称",
            fileName: uploadInfo.file.name,
          };
          _this.VideosDomain.GetVideoCertificate(
            params,
            function (data) {
              uploader.setUploadAuthAndAddress(uploadInfo, data.data.uploadAuth, data.data.uploadAddress, data.data.videoId);
              _this.videoId = data.data.videoId;
            },
            function (error) {
              _this.$message.error("视频上传失败！");
              loading.close();
            }
          );
          // }
        },
        //文件上传成功
        onUploadSucceed: function (uploadInfo) {
          _this.resVideo = "http://video.qyyl365.com/" + uploadInfo.object;
        },
        //文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          _this.uploaded = false;
          loading.close();
          uploader.stopUpload();
        },
        //文件上传进度，单位：字节
        onUploadProgress: function (uploadInfo, totalSize, loadedPercent) {
          // _this.percentage = parseInt((loadedPercent * 100).toFixed(2))
        },
        //上传凭证过期
        onUploadTokenExpired: function (uploadInfo) {
          console.log("1111111");
          // loading.close();
        },
        //全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          _this.uploaded = true;
        },
      });
      return uploader;
    },
    getShopSetting() {
      var _this = this;
      _this.CommodityDomain.GetShopSetting(
        function (data) {
          _this.isShare = data.data.isShare;
        },
        function (err) {
          console.log(err);
        }
      );
    },
    checkChargebackMoney() {
      this.errorChargebackMoney = "";
      if (this.commodityForm.chargebackType > 1) {
        if (!this.regMoney.test(this.commodityForm.chargebackMoney)) {
          this.errorChargebackMoney = "请输入正确的金额(小数点后保留两位)";
          this.commodityForm.chargebackMoney = 1;
          return;
        }
      }
    },
    checkLimitNum() {
      this.errorLimitNum = "";
      var reg = /^[1-9]\d*$/;
      if (this.commodityForm.limitType > 0) {
        if (!reg.test(this.commodityForm.limitNum)) {
          this.errorLimitNum = "请输入正确的限购数量(大于0，小于10000的正整数)";
          this.commodityForm.limitNum = 1;
          return;
        }
      }
    },
    checkMoney() {
      this.errorStr = "";
      if (this.commodityForm.freightType == 1) {
        if (!this.regMoney.test(this.commodityForm.freightMoney)) {
          this.errorStr = "请输入正确的金额(小数点后保留两位)";
          this.commodityForm.freightMoney = 0;
          return;
        }
      }
    },
    goBack() {
      this.$router.push("/ShopMall/commodity");
      // this.$router.go(-1);
    },
    LoadCategory(success, error) {
      var _this = this;
      _this.CommodityCategoryDomain.Categories(
        function (data) {
          _this.commodifyCategory = data.data;
        },
        function (err) {
          console.log(err);
        }
      );
    },

    addBtn(i) {
      const routerData = this.$router.resolve({
        path: "/ShopMall/FreightAdd",
        query: { id: i },
      });
      window.open(routerData.href, "_blank");
    },
    LoadFreightTemplate() {
      var _this = this;
      _this.freightTemplate = [];
      _this.CommodityDomain.FreightTemplate(
        _this.organizationId,
        function (data) {
          _this.freightTemplate = data.data;
          // 设置默认选项
          _this.commodityForm.freightTemplateId = _this.freightTemplate[0].id;
        },
        function (err) {
          console.log(err);
        }
      );
    },
    //规格增删改---------开始
    handleAdd() {
      let row = {
        edit: true,
        name: "",
        coverImageUrls: "",
        guidancePrice: null,
        ordinaryPrice: null,
        stockNum: null,
        state: 1,
        rank: 0,
      };
      this.commodityForm.commoditySpecifications.push(row);
    },
    confirmData(row) {
      row.edit = false;
    },
    handleDelete(row, index) {
      this.commodityForm.commoditySpecifications.splice(index, 1);
    },
    //规格增删改---------结束
    handleChange(value) {
      var _this = this;
      _this.commodityForm.categoryId = value;
      // _this.CommodityCategoryDomain.CommonParameter(
      //   value,
      //   function (data) {
      //     _this.commodityForm.commodityParameters = [];
      //     data.data.forEach((item, i) => {
      //       _this.commodityForm.commodityParameters.push({
      //         id: 0,
      //         parameterId: item.id,
      //         key: item.key,
      //         value: item.value,
      //       });
      //     });
      //   },
      //   function (err) {
      //     console.log(err);
      //   }
      // );
    },
    handleImagePreview(file) {
      this.Image.dialogImageUrl = file.url;
      this.Image.dialogVisible = true;
    },
    saveCommodity(formName) {
      var _this = this;
      let imageUrls = this.commodityForm.imageUrls.filter((i) => i);
      if (imageUrls.length == 0) {
        this.imgTip = "请至少上传一张主图";
      } else {
        this.imgTip = "";
      }
      this.commodityForm.coverImageUrls = imageUrls.toString();
      let arry = this.commodityForm.commoditySpecifications;
      if (arry.length == 0) {
        this.errStr = "请完善商品规格信息";
      } else {
        this.errStr = "";
      }
      this.$refs[formName].validate((valid) => {
        if (valid && !this.imgTip && !this.errStr) {
          var item = this.commodityForm;
          if (_this.id) {
            _this.CommodityDomain.EditCommodity(
              _this.commodityForm,
              function (data) {
                _this.steps = 5;
                _this.successCode = data.data;
              },
              function (err) {}
            );
          } else {
            _this.CommodityDomain.AddCommodity(
              item,
              function (data) {
                _this.steps = 5;
                _this.successCode = data.data;
              },
              function (err) {}
            );
          }
        } else {
          _this.$message({
            type: "error",
            message: "请完善商品信息",
          });
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.navbar-expand-lg {
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -ms-flex-pack: start;
  justify-content: flex-start;
}

.navbar {
  position: relative;
  height: 73px;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.header {
  flex: 1;
  text-align: right;
  margin-right: 15px;
}

.messages {
  margin-top: 13px;
  margin-right: 20px;
}

.messages .el-icon-bell {
  font-size: 26px;
}

.from-box {
  height: calc(100% - 50px);
  overflow-x: hidden;
  width: 100%;
}

.from-box .el-form {
  max-width: 1200px;
  width: 80%;
}

.form-item {
  padding-top: 30px;
}

.form-item .el-form .el-cascader {
  width: 100%;
}

.isShare-box > div {
  display: inline-block;
  /* margin: 0 20px 0 0; */
}

.isShare-box > div .el-input {
  width: 70px;
}

.tab /deep/ .el-form-item__content {
  height: 55px;
}

.tab /deep/ .el-form-item__content .el-form-item__error {
  top: 40px;
}

._table {
  width: 60%;
  border-collapse: collapse;
  border: 0px;
}

._table thead tr {
  font-size: 13px;
  color: #2e3b45;
  text-align: center;
  background-color: rgba(230, 255, 250, 0.92);
  font-weight: bold;
}

._table td {
  line-height: 30px;
  text-align: center;
  padding: 4px 10px 3px 10px;
  height: 18px;
  border: 1px solid #ebeef5;
}

._table /deep/ .el-form-item__error {
  top: 88%;
}
::v-deep .is-finish,
::v-deep .is-process,
::v-deep .is-wait {
  cursor: pointer;
}
.imgBox {
  width: 140px;
  height: 140px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px dashed #d9d9d9;
  margin-right: 20px;
  cursor: pointer;
}
.imgBox2 {
  width: 40px;
  height: 40px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px dashed #d9d9d9;
  margin-right: 5px;
  cursor: pointer;
}
.imgBox .dropdown,
.imgBox2 .dropdown {
  width: 100%;
  height: 100%;
}
.imgBox .dropdown ::v-deep img,
.imgBox2 .dropdown ::v-deep img {
  width: 100%;
  height: 100%;
  border-radius: 12px;
}
.el-form-imgBox ::v-deep .el-form-item__content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.imgTip {
  font-size: 12px;
  color: #0a72d3;
}
</style>
<style scoped lang="scss">
.dialog-box {
  height: 60vh;
  .iq-card-body {
    position: relative;
  }
  .left-box {
    width: 20%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .right-box {
    width: 76%;
  }
  .line-box {
    width: 1px;
    background: #e6e6e6;
    height: 100%;
  }
  .input-box {
    padding: 10px 0;
  }
  .item-box {
    border-radius: 4px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    padding: 0 10px;
    margin-bottom: 5px;
  }
  .top-box {
    font-size: 16px;
  }
  .box {
    position: absolute;
    width: calc(20% + 40px);
    left: 0;
    bottom: 0;
    right: 0;
    border-top: 1px solid #f0f0f0;
  }
  .bottom-box {
    width: 50%;
    height: 60px;
    cursor: pointer;
  }
  .line-box2 {
    width: 1px;
    background: #e6e6e6;
    height: 30px;
  }
  .item-box:hover {
    background: #f0f5ff;
    color: #0a72d3;
  }
  .active {
    background: #f0f5ff;
    color: #0a72d3;
  }
  .img-box {
    width: 160px;
    height: 200px;
    border-radius: 12px;
    margin-right: 20px;
    position: relative;
    margin-bottom: 10px;
  }
  .img-box img {
    width: 160px;
    height: 160px;
    border-radius: 12px;
  }
  .img-box .top-btn {
    width: 80%;
    position: absolute;
    right: 10px;
    top: 5px;
  }
  .img-box .top-btn ::v-deep .el-checkbox__inner {
    border: 1px solid #ffffff;
    background-color: #ccc;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: var(--base--Color);
  }
  .input-box2 {
    padding: 10px 0;
    width: 40%;
    margin-right: 20px;
  }
}
</style>
